import { render, staticRenderFns } from "./SociosMetricas.vue?vue&type=template&id=016851fd&scoped=true"
import script from "./SociosMetricas.vue?vue&type=script&lang=js"
export * from "./SociosMetricas.vue?vue&type=script&lang=js"
import style0 from "./SociosMetricas.vue?vue&type=style&index=0&id=016851fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016851fd",
  null
  
)

export default component.exports